(function ($, Drupal, drupalSettings) {
  'use strict';
  Drupal.behaviors.accordion = {
    attach: function (context, settings) {
      $('.component-accordion:not(.component-accordion--js-initialized)').each(function (index) {
        // Initialize variables.
        var $widget = $(this);
        var $accordionContainer = $widget.children('.component-accordion__content');
        var $accordionItems = $accordionContainer.find('.component-accordion-item');
        var $accordionItemHeaders = $accordionItems.find('.component-accordion-item__trigger');

        // Mark that the accordion component has been initialized.
        $widget.addClass('component-accordion--js-initialized');

        // Attach each accordion item header to its content and hide content
        // that should be hidden.
        $accordionItems.each(function (accordionItemIndex) {

          var $accordionItem = $(this);
          var $accordionItemHeader = $accordionItem.find('.component-accordion-item__trigger').first();
          var $accordionItemContent = $accordionItem.children('.component-accordion-item__content-wrapper');

          // Generate the accordion header and panel IDs.
          var accordionItemId = $accordionItem.attr('data-entity-id');
          var accordionItemHeaderId = 'component-accordion-item-' + accordionItemId + '__header';
          var accordionItemPanelId = 'component-accordion-item-' + accordionItemId + '__panel';

          // Determine whether this accordion needs to be open by default.
          var openByDefault = $accordionItem.hasClass('component-accordion-item--open');

          // Set up accordion header with proper ARIA attributes.
          // Each header is focusable via Tab (tabindex 0) per WAI-ARIA accordion pattern.
          $accordionItemHeader
            .attr('aria-controls', accordionItemPanelId)
            .attr('aria-expanded', (openByDefault) ? 'true' : 'false')
            .attr('id', accordionItemHeaderId)
            .attr('role', 'button')
            .attr('tabindex', '0');

          // Set up accordion panel with proper ARIA attributes.
          $accordionItemContent
            .attr('aria-labelledby', accordionItemHeaderId)
            .attr('id', accordionItemPanelId)
            .attr('role', 'region');

          if (!openByDefault) {
            $accordionItemContent
              .attr('aria-hidden', 'true')
              .attr('hidden', true)
              .prop('inert', true);
          }
        });

        // Handle accordion open/close on click or Enter/Space keydown.
        $accordionItemHeaders.on('click keydown', function (e) {
          if (e.type === 'click' || (e.type === 'keydown' && [13, 32].indexOf(e.keyCode) !== -1)) {
            if (e.type === 'keydown') {
              e.preventDefault();
            }

            var $accordionItemHeader = $(this);
            var $accordionItem = $accordionItemHeader.closest('.component-accordion-item');
            var $accordionItemContent = $accordionItem.children('.component-accordion-item__content-wrapper');
            var open = $accordionItem.hasClass('component-accordion-item--open');

            $accordionItem.toggleClass('component-accordion-item--open', (!open));
            $accordionItemHeader.attr('aria-expanded', (open) ? 'false' : 'true');

            if (open) {
              $accordionItemContent
                .attr('aria-hidden', 'true')
                .attr('hidden', true)
                .prop('inert', true);
            }
            else {
              $accordionItemContent
                .removeAttr('aria-hidden')
                .removeAttr('hidden')
                .prop('inert', false);
            }

            // Re-apply focus after DOM mutation to preserve focus ring in NVDA.
            // Only keyboard-triggered clicks (e.detail === 0) need this; mouse
            // clicks must be skipped to avoid breaking :focus-visible in Safari.
            if (e.detail === 0) {
              $accordionItemHeader[0].focus();
            }
          }
        });
      });
    }
  };

})(jQuery, Drupal, drupalSettings);


